module.exports=function(scope){ return `<li class="mdl-list__item asseco-window-chat-client-message">
    <span class="mdl-list__item-primary-content">
        <span style="width: 100%;">${scope.message}</span>
    </span>
    <span class="asseco-window-chat-message-time">${scope.time}</span>
</li>`};